export default "__VITE_ASSET__BYTbGmsR__"